import { InjectionToken } from '@angular/core';
import { EqaAriaDialogContext } from '@shared/domain/interfaces/dialog-aria-context';
import { Observable } from 'rxjs';

export const EQA_DIALOGS = new InjectionToken<ReadonlyArray<Observable<ReadonlyArray<EqaAriaDialogContext>>>>(
	'A stream of dialogs',
);
